import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { isNativeMobileApp } from "../utils/nativeImagePicker";
import "./IosBackButton.css";

const isIOS = () => {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};

function IosBackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  const canGoBack = window.history.length > 1;
  const isHome = location.pathname === "/";

  if (!isNativeMobileApp() || !isIOS() || !canGoBack || isHome) {
    return null;
  }

  return (
    <button
      className="ios-back-button"
      onClick={() => navigate(-1)}
      aria-label="Zurück"
      title="Zurück"
    >
      ‹
    </button>
  );
}

export default IosBackButton;